/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF

import React from "react";
import { useField, useFormikContext } from "formik";

import DropdownPR from "../../PrimeReact/DropdownPR";

export default function Dropdown(props) {
  const [field, meta] = useField(props);
  const { handleBlur } = useFormikContext();
  return (
    <>
      <DropdownPR handleBlur={handleBlur} field={field} {...props} />
      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </>
  );
}
